/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowCar200ResponseData } from './ShowCar200ResponseData';
import {
    ShowCar200ResponseDataFromJSON,
    ShowCar200ResponseDataFromJSONTyped,
    ShowCar200ResponseDataToJSON,
    ShowCar200ResponseDataToJSONTyped,
} from './ShowCar200ResponseData';

/**
 * 
 * @export
 * @interface ShowCar200Response
 */
export interface ShowCar200Response {
    /**
     * 
     * @type {ShowCar200ResponseData}
     * @memberof ShowCar200Response
     */
    data?: ShowCar200ResponseData;
}

/**
 * Check if a given object implements the ShowCar200Response interface.
 */
export function instanceOfShowCar200Response(value: object): value is ShowCar200Response {
    return true;
}

export function ShowCar200ResponseFromJSON(json: any): ShowCar200Response {
    return ShowCar200ResponseFromJSONTyped(json, false);
}

export function ShowCar200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowCar200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ShowCar200ResponseDataFromJSON(json['data']),
    };
}

export function ShowCar200ResponseToJSON(json: any): ShowCar200Response {
    return ShowCar200ResponseToJSONTyped(json, false);
}

export function ShowCar200ResponseToJSONTyped(value?: ShowCar200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShowCar200ResponseDataToJSON(value['data']),
    };
}

